import { TradingDatagridV3Interface } from '@trading-ui/datagrid-v3';
import { create } from 'zustand';

interface ConsumerTableStoreState {
  tableInstance: TradingDatagridV3Interface | null;
  lastEditedRowId: number | null;
  lastEditedRowIndex: number | null;
  lastEditedColumnField: string | null;
  restoreSelectionUntil: number | null;
  saveTableInstance: (tableInstance: TradingDatagridV3Interface) => void;
  setLastEditedRowId: (rowId: number | null) => void;
  setLastEditedRowIndex: (rowIndex: number | null) => void;
  setLastEditedColumnField: (field: string | null) => void;
  setRestoreSelectionUntil: (until: number | null) => void;
}

const useConsumerTableStore = create<ConsumerTableStoreState>((set) => ({
  tableInstance: null,
  lastEditedRowId: null,
  lastEditedRowIndex: null,
  lastEditedColumnField: null,
  restoreSelectionUntil: null,
  saveTableInstance: (tableInstance) => set((state) => ({ ...state, tableInstance })),
  setLastEditedRowId: (rowId) => set((state) => ({ ...state, lastEditedRowId: rowId })),
  setLastEditedRowIndex: (rowIndex) => set((state) => ({ ...state, lastEditedRowIndex: rowIndex })),
  setLastEditedColumnField: (field) => set((state) => ({ ...state, lastEditedColumnField: field })),
  setRestoreSelectionUntil: (until) => set((state) => ({ ...state, restoreSelectionUntil: until })),
}));

export default useConsumerTableStore;
